import { ConfigurationItem } from "@shared/types";
import React from "react";
import { CreateTradeSections } from "@shared/features/tradingTerminal/common/types";

export const WebTradingTerminalContext = React.createContext<
  | {
      sectionToComponent: Record<CreateTradeSections, React.JSX.Element>;
      trailingComponent: React.JSX.Element;
      trailingModifiedConfiguration: ConfigurationItem | undefined;
    }
  | undefined
>(undefined);
